import Typography from '@ixigo/iui/Typography';
import clsx from 'clsx';
import { useEffect, useState, ReactNode } from 'react';
import { CloseCircleFilled } from '@ixigo/icons';

interface BottomToastProps {
    heading: string;
    visible: boolean;
    onBackdropClick?: () => void;
    icon: ReactNode;
}

const BottomToast = ({ heading, visible, onBackdropClick, icon }: BottomToastProps) => {
    const [isVisible, setIsVisible] = useState(visible);

    useEffect(() => {
        if (visible) {
            setIsVisible(true);
            // Auto-dismiss after 5 seconds
            const timer = setTimeout(() => {
                if (onBackdropClick) onBackdropClick();
            }, 5000);
            return () => clearTimeout(timer);
        }
        const hideTimer = setTimeout(() => setIsVisible(false), 300);
        return () => clearTimeout(hideTimer);
    }, [visible, onBackdropClick]);

    if (!isVisible) return null;

    return (
        <div
            className={clsx(
                'fixed left-0 right-0 flex items-center justify-center z-50 transition-transform duration-300 pointer-events-none',
                visible ? 'bottom-40 translate-y-0' : '-bottom-40 translate-y-full',
            )}
        >
            <div className='pointer-events-auto shadow-xl shadow-zinc-900/30 bg-zinc-900 rounded-xl min-h-14 h-14 w-[calc(100vw-30px)] max-w-[420px] px-15 py-10 flex items-center gap-10'>
                {icon}
                <Typography
                    variant='body-sm'
                    className='grow text-white text-sm font-thin leading-[140%] flex items-start flex-col text-left'
                >
                    {String(heading)
                        .split('\n')
                        .map((line) => (
                            <span key={line} className='block'>
                                {line}
                            </span>
                        ))}
                </Typography>
                <button
                    type='button'
                    onClick={onBackdropClick}
                    className='flex items-center justify-center rounded-full hover:bg-neutral-800 transition-colors leading-none'
                    aria-label='Close'
                >
                    <CloseCircleFilled width={20} height={20} className='text-white' />
                </button>
            </div>
        </div>
    );
};

export default BottomToast;
